import clsMerge from "../util/clsMerge";

/**
 * This component is used to display a banner with buttons.
 *
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The children to display in the banner.
 */
export default function AbstractBannerButtonFrame({
	children,
	className,
}: {
	children: React.ReactNode;
	className?: string;
}) {
	return (
		<div
			className={clsMerge(
				"flex justify-start gap-2 overflow-x-scroll border-0 px-4 pb-4 md:z-course-filter-header md:overflow-hidden md:rounded-full md:border md:border-gray-400 md:bg-gray-200 md:px-6 md:py-5 md:shadow-lg",
				className
			)}
		>
			{children}
		</div>
	);
}
